<template>
  <div class="evaluation-container">
    <h3>EVALUACIÓN DE RIESGO</h3>
        
    <div class="risk-type-display">
      <label>Fase de Evaluación:</label>
      <div class="risk-type-badge" :class="evaluationType">
        {{ evaluationType === 'inherent' ? 'INHERENTE (Sin Controles)' : 'RESIDUAL (Con Controles)' }}
      </div>
    </div>

    <label for="index_a">Índice de personas expuestas (A)</label>
    <select v-model.number="data.index_a" id="index_a">
        <option :value="1">1 - Moderado</option>
        <option :value="2">2 - Alto</option>
        <option :value="3">3 - Muy Alto</option>
    </select>

    <label for="index_b">Índice de procedimientos (B)</label>
    <select v-model.number="data.index_b" id="index_b">
        <option :value="1">1 - Moderado</option>
        <option :value="2">2 - Alto</option>
        <option :value="3">3 - Muy Alto</option>
    </select>

    <label for="index_c">Índice de capacitación (C)</label>
    <select v-model.number="data.index_c" id="index_c">
        <option :value="1">1 - Moderado</option>
        <option :value="2">2 - Alto</option>
        <option :value="3">3 - Muy Alto</option>
    </select>

    <label for="index_d">Índice de exposición al riesgo (D)</label>
    <select v-model.number="data.index_d" id="index_d">
        <option :value="1">1 - Moderado</option>
        <option :value="2">2 - Alto</option>
        <option :value="3">3 - Muy Alto</option>
    </select>

    <label for="severity">Índice de severidad (S)</label>
    <select v-model.number="data.severity" id="severity">
        <option :value="1">1 - Moderado</option>
        <option :value="2">2 - Alto</option>
        <option :value="3">3 - Muy Alto</option>
    </select>

    <div class="checkbox-wrapper readonly">
      <div class="custom-checkbox" :class="{ checked: data.signification }">
        <svg v-if="data.signification" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </div>
      <span class="checkbox-label">
        Riesgo Significativo: <strong>{{ data.signification ? 'SÍ' : 'NO' }}</strong>
      </span>
    </div>
        
    <div class="botones">
      <button type="button" @click="showIPSSOBOTModalMethod">
        <img src="@/assets/img/expandirchat.png" alt="Chat icon" /> 
        Consultar a IPSSOBOT
      </button>
      </div>

    <IPSSOBOTModal
        :isOpen="showIPSSOBOTModal"
        @closeModal="showIPSSOBOTModal = $event"
        :chatGptPrompt="chatGptPrompt"
    />
  </div>
</template>

<script>
import IPSSOBOTModal from "./IPSSOBOTModal.vue";

export default {
    name: "EvaluationForm",
    props: {
        cleanAll: Boolean,
        risk: Number,
        evaluationType: String
    },
    components: { IPSSOBOTModal },
    emits: ['risk-evaluation'],
    data() {
        return {
            showIPSSOBOTModal: false,
            chatGptPrompt: '',
            riskId: 0,
            
            data: {
                index_a: 1,
                index_b: 1,
                index_c: 1,
                index_d: 1,
                severity: 1,
                signification: false 
            }
        };
    },
    computed: {
        // 1. Calculamos la Probabilidad Total (P)
        probability() {
            return this.data.index_a + this.data.index_b + this.data.index_c + this.data.index_d;
        },
        // 2. Calculamos el Nivel de Riesgo (P x S)
        riskLevel() {
            return this.probability * this.data.severity;
        }
    },
    watch: {
        cleanAll(val) { if(val) this.clearInputsData(); },
        risk(val) { this.riskId = val; },

        // 3. EL CEREBRO AUTOMÁTICO
        // Cada vez que cambie el nivel de riesgo, decidimos si es significativo
        riskLevel(newVal) {
            // REGLA: Si el riesgo es mayor a 8 (Moderado, Importante, Intolerable), es Significativo.
            // Si es 8 o menos (Tolerable, Trivial), NO es significativo.
            this.data.signification = newVal > 8; 
            
            console.log(`Cálculo auto: Nivel ${newVal} -> Significativo: ${this.data.signification}`);
        }
    },
    methods: {
        submitForm() {
             // Enviamos también los cálculos matemáticos para que se guarden en BD
             const payload = {
                ...this.data,
                probability: this.probability, // Enviamos P
                riskLevel: this.riskLevel,     // Enviamos PxS
                newRiskType: this.evaluationType
             };
             
             this.$emit('risk-evaluation', payload);
        },
        clearInputsData() {
            this.data = {
                index_a: 1, index_b: 1, index_c: 1, index_d: 1, severity: 1, signification: false
            };
        },
        
        showIPSSOBOTModalMethod() {
            this.showIPSSOBOTModal = true;
            if (this.riskId) this.getRisk(this.riskId);
        },
        async getRisk(id) {
             try {
                const response = await this.$axios.get(`/chatbot/risk/${id}`);
                this.createPrompt(response.data.description);
             } catch(e) { console.error(e); }
        },
        createPrompt(risk) { // eslint-disable-line no-unused-vars
        }
    }
};
</script>

<style scoped>
/* --- TÍTULO --- */
h3 {
  font-family: "Anek Latin", sans-serif;
  font-weight: 800;
  font-size: 15px;
  margin: 0px 0px 15px 0px;
  text-transform: uppercase;
  color: #000;
  text-align: left;
}

/* --- ETIQUETAS (LABELS) --- */
label {
  font-family: "Anek Latin", sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: #000;
  margin-bottom: 5px;
  display: block;
  text-align: left;
}

/* --- SELECTS (LISTAS DESPLEGABLES) --- */
select {
  width: 100%;
  max-width: 332px;
  height: 25px;
  background: #eeeeee;
  border: 1px solid #ababab;
  border-radius: 4px;
  margin-bottom: 10px;
  font-family: "Anek Latin", sans-serif;
  font-size: 15px;
  padding-left: 5px;
  display: block;
}

select:focus {
  outline: none;
  border: 1px solid #f8bc02;
}

/* --- CHECKBOX PERSONALIZADO --- */
.checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 15px;
  margin-bottom: 15px;
  cursor: default;
  user-select: none;
  pointer-events: none; 
  opacity: 0.9;
}

.custom-checkbox {
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  border: 2px solid #ababab;
  border-radius: 4px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.custom-checkbox.checked {
  background: #f8bc02;
  border-color: #f8bc02;
}

.custom-checkbox svg {
  width: 14px;
  height: 14px;
  color: white;
}

.checkbox-label {
  font-family: "Anek Latin", sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: #000;
}

.checkbox-wrapper:hover .custom-checkbox {
  border-color: #f8bc02;
}

/* --- BOTONES --- */
.botones {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  width: 100%;
}

.botones button {
  background: white;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  border: 3px solid #f8bc02;
  border-radius: 10px;
  cursor: pointer;
  font-family: "Anek Latin", sans-serif;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
  max-width: 280px;
  gap: 8px;
  transition: all 0.2s;
}

.botones button:hover {
  background: #f8bc02;
  color: white;
}

.botones button img {
  width: 20px;
  height: auto;
}

.btn-submit {
  background: #f8bc02;
  color: white;
  border: 3px solid #f8bc02;
}

.btn-submit:hover {
  background: #d9a602;
  border-color: #d9a602;
}

/* Ajuste general del formulario */
form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 332px;
  margin: 0 auto;
}

.risk-type-display {
  margin-bottom: 15px;
}

.risk-type-badge {
  padding: 8px 15px;
  border-radius: 8px;
  font-weight: 700;
  text-align: center;
  font-size: 14px;
}

.risk-type-badge.inherent {
  background: #ffebee;
  color: #c62828;
  border: 2px solid #ef5350;
}

.risk-type-badge.residual {
  background: #e8f5e9;
  color: #2e7d32;
  border: 2px solid #66bb6a;
}

/* Animaciones de entrada/salida */
.form-wrapper {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.phase-indicator {
  animation: slideDown 0.4s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>